import React from 'react';
import propTypes from 'prop-types';
export const InsuranceIcon = ({ size = 18, color = 'black' }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      fill={color}
      stroke={color}
      strokeWidth="1"
      version="1.1"
      id="Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 60 60"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <path
            d="M59,20H40V1c0-0.6-0.4-1-1-1H21c-0.6,0-1,0.4-1,1v19H1c-0.6,0-1,0.4-1,1v18c0,0.6,0.4,1,1,1h19v19c0,0.6,0.4,1,1,1h11v-2
           H22V39c0-0.6-0.4-1-1-1H2V22h19c0.6,0,1-0.4,1-1V2h16v19c0,0.6,0.4,1,1,1h19v17h2V21C60,20.4,59.6,20,59,20z"
          />
          <path d="M53,43H43c-3.9,0-7,3.1-7,7v10h2V50c0-2.8,2.2-5,5-5h4v7h2v-7h4c2.8,0,5,2.2,5,5v10h2V50C60,46.1,56.9,43,53,43z" />
          <path
            d="M47,42h2c2.8,0,5-2.2,5-5v-3c0-2.8-2.2-5-5-5h-2c-2.8,0-5,2.2-5,5v3C42,39.8,44.2,42,47,42z M44,34c0-1.7,1.3-3,3-3h2
           c1.7,0,3,1.3,3,3v3c0,1.7-1.3,3-3,3h-2c-1.7,0-3-1.3-3-3V34z"
          />
          <rect x="41" y="53" width="2" height="7" />
          <rect x="53" y="53" width="2" height="7" />
          <rect x="24" y="4" width="2" height="2" />
          <rect x="4" y="24" width="2" height="2" />
          <rect x="54" y="24" width="2" height="2" />
          <rect x="4" y="34" width="2" height="2" />
          <rect x="24" y="54" width="2" height="2" />
          <rect x="34" y="4" width="2" height="2" />
          <rect x="42" y="16" width="2" height="2" />
          <rect x="46" y="16" width="2" height="2" />
          <rect x="50" y="16" width="2" height="2" />
          <rect x="16" y="16" width="2" height="2" />
          <rect x="12" y="16" width="2" height="2" />
          <rect x="8" y="16" width="2" height="2" />
          <rect x="16" y="42" width="2" height="2" />
          <rect x="12" y="42" width="2" height="2" />
          <rect x="16" y="46" width="2" height="2" />
          <rect x="16" y="50" width="2" height="2" />
          <rect x="12" y="46" width="2" height="2" />
          <rect x="8" y="42" width="2" height="2" />
          <rect x="16" y="12" width="2" height="2" />
          <rect x="16" y="8" width="2" height="2" />
          <rect x="12" y="12" width="2" height="2" />
          <rect x="46" y="12" width="2" height="2" />
          <rect x="42" y="12" width="2" height="2" />
          <rect x="42" y="8" width="2" height="2" />
        </g>
      </g>
    </svg>
  );
};
InsuranceIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
InsuranceIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
